import { css } from '@emotion/react';
import type { CommonHTMLButtonAttributes } from '@frontend/types';
import { theme } from '@frontend/theme';
import { CaretLeftIconSmall, CaretRightIconSmall } from '../../../icon';
import { NakedButton } from '../../../naked';

type CarouselArrowProps = CommonHTMLButtonAttributes & {
  direction: 'left' | 'right';
  show: boolean;
  trackingId?: string;
};

export const CarouselArrow = ({ direction, show, ...rest }: CarouselArrowProps) => {
  if (!show) return null;

  const IconComponent = direction === 'left' ? CaretLeftIconSmall : CaretRightIconSmall;

  return (
    <NakedButton {...rest} css={getArrowStyles(direction)}>
      <IconComponent />
    </NakedButton>
  );
};

const getArrowStyles = (direction: 'left' | 'right') => {
  return css({
    position: 'absolute',
    top: '50%',
    transform: 'translateY(-50%)',
    cursor: 'pointer',
    padding: `${theme.spacing(1.5)} ${theme.spacing(0.5)}`,
    boxShadow: '0px 4px 8px 3px #00215226',
    zIndex: 1,
    height: '100%',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    background: theme.colors.white,
    [direction]: `-${theme.spacing(2)}`,
  });
};
